module.exports = __webpack_public_path__ + "media/images/icons/ic-textfield-warning-94cc579691dd2cd7c0e9b9987467717f.svg";